import { useTracking } from './TrackingContext';
import { TrackingData } from './TrackingContext.types';

interface TrackEvent {
    (name: string, value: any, global?: TrackingData): void;
}

export const useTrackEvent = (): TrackEvent => {
    const { context, updateContext } = useTracking();

    const trackEvent: TrackEvent = (name, value, global?) => {
        const eventData = {
            ...context,
            [name]: value,
        };

        if (global !== undefined)  {
            updateContext(global)
        }

        console.log('Send to Segment? [Event]: ', name, value);
        console.log('Send to Segment? global [Event]: ', eventData);
    };

    return trackEvent;
};
